import React from "react";

/**
 * A small map pin, the same teardrop as the job tracker markers on the map
 * (helpers/pinIcon.js). Decorative: the text next to it says what it means.
 */
export default function PinGlyph({ color, holeColor = "#fff", outline = "#fff", height = 13, className }) {
  return (
    <svg
      className={className}
      width={(height * 10) / 13}
      height={height}
      viewBox="0 0 10 13"
      aria-hidden="true"
      focusable="false"
      data-testid="pin-glyph"
    >
      <path
        d="M5 .6A4.4 4.4 0 0 0 .6 5c0 3.1 4.4 7.3 4.4 7.3S9.4 8.1 9.4 5A4.4 4.4 0 0 0 5 .6z"
        fill={color}
        stroke={outline}
        strokeWidth="1"
      />
      <circle cx="5" cy="5" r="1.6" fill={holeColor} />
    </svg>
  );
}
